<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { setPageTitle } from '@/@core/utils/pageMetaUtils'
import SubmissionDetail from '@/views/Sbr/SubmissionDetail.vue'

setPageTitle(PageMeta.Sbr.Submission.Title)
definePage({ meta: PageMeta.Sbr.Submission.Meta })

const route = useRoute()

const guid = computed(() => {
  const value = (route.params as Record<string, unknown>).guid

  return typeof value === 'string' ? value : ''
})
</script>

<template>
  <SubmissionDetail :guid="guid" />
</template>
